<template>
  <div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar scrape_id"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
      
      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>
      
      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>
    
    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>
    
    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label>Contas</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..."/>
        </div>

        <div class="col-md-3">
          <label>Scraping Service</label>
          <Select2 :options="filterServiceNames" v-model="query.scrapingServiceName"/>
        </div>
  
        <div class="col-md-3">
          <label for="request-status">Status</label>
          <Select2 id="request-status" :options="filterStatus" v-model="query.status"/>
        </div>

        <div class="col-md-3">
          <label for="request-executor">Executor</label>
          <Select2 id="request-executor" :options="filterExecutor" v-model="query.executor"/>
        </div>
      </div>
      
      <div class="row mt-4">
        <div class="col-md-3">
          <label for="request-sequence">Tentativa</label>
          <Select2 id="request-sequence" :options="filterSequence" v-model="query.sequence"/>
        </div>

        <div class="col-md-4">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="created_at">Data de criação</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="consult-day">Data inicial</label>
          <input v-model="query.startDate" type="date" id="consult-day" class="form-control">
        </div>
        
        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>
    
    <!-- Table -->
    <div class="row">
      <div class="col-sm-12">
        
        <div class="row mt-4">
          <div class="col-md-12">
            <strong class="mr-3">
              {{infoTotalModels}}
            </strong>
          </div>
        </div>
        
        <Table :requests="requests" :linkConsult="true"/>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>
      
      </div>
    </div>
    
  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import ModelMapper from '@/mixins/ModelMapper'

  import Select2 from '@/components/shares/Select2'
  import Table from '@/components/admin/maestro/request/Table'

  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'
  import { Converter } from '@/models/converter'

  const toCamelcase = string => {
    return new Converter({
      converterName: 'camelcase',
      data: string
    }).perform()
  }
  
  export default {
    components: { BadgeFilters, ChevronDownIcon, Pagination, SearchIcon, Select2, Table },
    computed: {
      badgeFilters() {
        return [
          this.filterAccount, this.filterEndDate, this.filterStatus,
          this.filterStartDate, this.filterServiceNames, this.filterSequence
        ]
      },
      requests() {
        return this.getModels || []
      },
    },
    created() {
      const date = new Date()
      date.setDate(date.getDate())
      this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))

      this.addOrderBy('updatedAt')
      this.$set(this.query, 'periodType', 'created_at')

      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })

      this.fetchScrapingServices()
      this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
    },
    data: () => ({
      accounts: [],
      currentRequest: null,
      filterAccount: null,
      filterServiceNames: null,
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      filterExecutor: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        table: ['Robot', 'Infosimples']
      }),
      filterStatus: new Filter({
        key: 'status',
        label: 'Status',
        table: [
          ['Processado', 'processed'],
          ['Em processo', 'processing'],
          ['Não processado', 'unprocessed'],
          ['Com erro', 'error'],
          ['Erro do sistema', 'processed_with_system_error'],
          ['Erro do usuário', 'processed_with_user_error']
        ]
      }),
      filterSequence: new Filter({
        key: 'sequence',
        label: 'Tentativa',
        table: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
      }),
      nameModel: 'Request',
      showModal: false,
    }),
    inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
    methods: {
      buildFilterServiceNames(services) {
        this.filterServiceNames = new Filter({
          key: 'scrapingServiceName',
          label: 'Serviço',
          table: services.map(s => [
            `${s.friendlyName} (${s.appName}) (${s.enable ? 'Ativo' : 'Inativo'})`,
            s.scraperName
          ])
        })
      },
      fetchScrapingServices() {
        const key = 'scrapingServiceToAdmin'
        const data = this.$ls.get(key)

        if (data) {
          this.buildFilterServiceNames(data)
          return
        }

        const params = {
          meta: false,
          per_page: 10000,
        }

        return this.axios.get('maestro/scraping_services', { params })
          .then(response => toCamelcase(response.data))
          .then(services => {
            this.$ls.set(key, services, { minutes: 5 })
            this.buildFilterServiceNames(services)
          })
          .catch(e => this.$notify.addError(e))
      },
      buildPath() {
        return 'admin/maestro/requests'
      },
      find() {
        this.asyncTemplateSelect()
      },
    },
    mixins: [ModelMapper],
    name: 'Index',
    watch: {
      allAccounts: {
        deep: true,
        handler(value) {
          this.filterAccount = this.buildFilterAccount(value.data)
        },
      },
      allUsers: {
        deep: true,
        handler(value) {
          this.filterEmail = this.buildFilterEmail(value.data)
        },
      }
    }
  }
</script>

<style scoped>
  .fa-angle-right {
    transition: transform .2s;
    margin-left: 8px;
  }
</style>